export interface Novel {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  rating: number;
  wordCount: string;
  status: 'completed' | 'ongoing';
  updateDate: string;
  chapters: number;
  tags: string[];
  content: string;
  views: number;
  favorites: number;
}

export const categories = [
  { name: '都市逆袭', slug: 'urban-revenge', icon: 'ri-sword-line', description: '草根崛起，逆天改命，热血逆袭之路' },
  { name: '后宫养成', slug: 'harem-development', icon: 'ri-hearts-line', description: '美人环绕，情感交织，养成系后宫爽文' },
  { name: '豪门总裁', slug: 'ceo-romance', icon: 'ri-vip-crown-line', description: '商界霸主，权谋争锋，总裁的极致宠溺' },
  { name: '战神归来', slug: 'war-god-returns', icon: 'ri-shield-flash-line', description: '王者归来，睥睨天下，战神的热血传奇' },
  { name: '医武双绝', slug: 'medical-martial', icon: 'ri-psychotherapy-line', description: '医术通天，武道巅峰，绝世高手的都市人生' },
  { name: '玄幻都市', slug: 'urban-fantasy', icon: 'ri-magic-line', description: '仙侠入世，异能觉醒，都市中的玄幻传奇' },
];

export const novels: Novel[] = [
  {
    id: 1,
    title: '都市最强赘婿',
    author: '风华绝代',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20man%20in%20modern%20black%20suit%20standing%20confidently%20in%20luxury%20city%20night%20scene%2C%20dramatic%20lighting%2C%20golden%20and%20dark%20tones%2C%20artistic%20illustration%20style%2C%20romantic%20urban%20fantasy%20atmosphere%2C%20high%20contrast%2C%20book%20cover%20aesthetic&width=400&height=560&seq=novel-cover-01&orientation=portrait',
    description: '三年隐忍，一朝崛起！他是豪门弃子，却拥有通天道法、绝世医术。当他摘下伪装的那一刻，整个世界为之颤抖。美艳总裁、高冷校花、绝色特工……纷纷倾心，看最强赘婿如何逆转人生，称霸都市！',
    category: '都市逆袭',
    categorySlug: 'urban-revenge',
    rating: 9.6,
    wordCount: '286万字',
    status: 'ongoing',
    updateDate: '2026-08-07',
    chapters: 1420,
    tags: ['逆袭', '赘婿', '热血', '美人环绕'],
    views: 12860000,
    favorites: 892000,
    content: '<h2>第一章 归来</h2><p>夜幕降临，华灯初上。</p><p>江城市中心，一栋高耸入云的摩天大楼顶层，一个身着黑色风衣的男人静静站在落地窗前，俯瞰着这座繁华都市。</p><p>他叫林风，三年前，他是江城最耀眼的商业天才，林家未来的继承人。然而一场阴谋，让他失去了一切。他被迫离开江城，远走他乡。</p><p>三年后，他回来了。</p><p>这一次，他不再是那个单纯的商业天才。三年间，他拜入隐世高人门下，习得通天医术、绝世武道。更在海外建立了庞大的商业帝国。</p><p>"江城，我回来了。"林风嘴角勾起一抹冷笑，"所有伤害过我的人，准备好迎接我的怒火了吗？"</p><p>就在这时，办公室的门被轻轻推开。</p><p>一个身着职业套裙的绝美女子走了进来。她有着一张精致到无可挑剔的面孔，修长的身姿，以及一双能让人沉醉的美眸。</p><p>"林总，苏氏集团的苏小姐想要见您。"女秘书恭敬地说道。</p><p>林风微微挑眉。苏氏集团，正是当年参与陷害他的势力之一。而那位苏小姐——苏晴雪，江城第一美女，更是他曾经的未婚妻。</p><p>在他最落魄的时候，苏晴雪当众撕毁婚约，让他沦为整个江城的笑柄。</p><p>"让她进来。"林风淡淡说道。</p><p>他要看看，这位曾经高高在上的苏大小姐，如今会以怎样的姿态出现在他面前。</p>',
  },
  {
    id: 2,
    title: '绝世神医在都市',
    author: '九天揽月',
    coverImage: 'https://readdy.ai/api/search-image?query=Handsome%20young%20Chinese%20doctor%20in%20white%20coat%20with%20mysterious%20golden%20energy%20around%20hands%2C%20standing%20in%20modern%20hospital%20corridor%2C%20dramatic%20contrast%20lighting%2C%20artistic%20illustration%2C%20warm%20golden%20and%20dark%20tones%2C%20book%20cover%20style&width=400&height=560&seq=novel-cover-02&orientation=portrait',
    description: '他是一位绝世神医，一手银针可起死回生，一身武艺可撼动乾坤。回归都市后，他本想低调行医，却被卷入豪门恩怨。绝色女总裁、清纯校花、火辣警花……各路美女纷至沓来，且看神医如何妙手回春，玩转都市！',
    category: '医武双绝',
    categorySlug: 'medical-martial',
    rating: 9.4,
    wordCount: '312万字',
    status: 'ongoing',
    updateDate: '2026-08-06',
    chapters: 1560,
    tags: ['神医', '武道', '都市', '逆袭'],
    views: 10500000,
    favorites: 756000,
    content: '<h2>第一章 山村少年</h2><p>云雾缭绕的深山中，一间简陋的茅草屋前，一个约莫二十岁的年轻人正在打坐练功。</p><p>他叫叶尘，自幼跟随师父在这深山中学医习武。如今师父仙逝，他按照师父遗命，下山前往都市。</p><p>"都市……"叶尘望着远方若隐若现的城市轮廓，心中既有期待，也有一丝不安。</p><p>师父说，他的身世与都市中的某个大家族有关。但更多的信息，师父还没来得及告诉他，便已撒手人寰。</p><p>背着破旧的行囊，叶尘踏上了前往江城的路。</p><p>刚到江城火车站，叶尘便遇到了麻烦。一群混混正在围殴一个中年人，周围的人纷纷避让，无人敢上前。</p><p>叶尘眉头一皱，大步走上前去。</p><p>"住手。"他的声音不大，却带着一种让人无法忽视的力量。</p><p>"哟，哪来的乡巴佬？"为首的混混头子一脸不屑，"识相的赶紧滚，否则连你一起打！"</p><p>叶尘没有说话，只是伸出了一根手指。</p><p>下一秒，那根手指轻轻点在了混混头子的胸口。混混头子整个人如遭电击，瞬间瘫软在地。</p>',
  },
  {
    id: 3,
    title: '总裁的绝色娇妻',
    author: '墨染青衣',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20beautiful%20Chinese%20woman%20in%20luxury%20red%20evening%20dress%20standing%20in%20grand%20ballroom%2C%20crystal%20chandeliers%2C%20romantic%20atmosphere%2C%20soft%20golden%20lighting%2C%20artistic%20illustration%20style%2C%20dramatic%20and%20elegant%20composition&width=400&height=560&seq=novel-cover-03&orientation=portrait',
    description: '一场商业联姻，让平凡女孩林若溪嫁给了权势滔天的冷面总裁。原以为是冰冷无爱的婚姻，却在朝夕相处中，她发现这位总裁大人有着不为人知的温柔。而他宠她的方式，让全世界都为之嫉妒。',
    category: '豪门总裁',
    categorySlug: 'ceo-romance',
    rating: 9.5,
    wordCount: '198万字',
    status: 'completed',
    updateDate: '2026-07-28',
    chapters: 980,
    tags: ['总裁', '宠文', '先婚后爱', '甜宠'],
    views: 15200000,
    favorites: 1020000,
    content: '<h2>第一章 契约婚姻</h2><p>林若溪站在民政局门口，手中拿着一个红色的本子——结婚证。</p><p>从今天起，她就是顾景琛的妻子了。</p><p>顾景琛，顾氏集团的掌舵人，江城最有权势的男人。而这场婚姻，不过是一场商业联姻。她的父亲为了挽救濒临破产的林氏，将她"嫁"给了这个男人。</p><p>"上车。"一辆黑色的劳斯莱斯停在她面前，车窗缓缓降下，露出顾景琛冷峻如刀削般的侧脸。</p><p>林若溪深吸一口气，拉开车门坐了进去。</p><p>车内安静得可怕。顾景琛一言不发地开着车，仿佛身边的不是他的新婚妻子，而是一个无关紧要的陌生人。</p><p>"我知道你不愿意。"突然，顾景琛开口了，声音低沉而冷淡，"但这桩婚事已成定局。只要你安分守己，我不会亏待你。"</p><p>林若溪咬紧嘴唇，没有说话。</p><p>车子驶入了一座位于半山腰的豪华别墅。这是顾景琛的私人府邸，占地数千平方米，光是花园就比林若溪以前住的地方还要大。</p><p>"以后你就住在这里。"顾景琛把一把钥匙扔给她，"二楼最里面的房间是你的。没有我的允许，不要进我的书房。"</p><p>说完，他头也不回地走进了别墅。</p>',
  },
  {
    id: 4,
    title: '战神归来之都市风云',
    author: '龙行天下',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20powerful%20Chinese%20man%20in%20military%20style%20black%20coat%20standing%20on%20rooftop%20overlooking%20city%20at%20night%2C%20stormy%20sky%2C%20dramatic%20atmosphere%2C%20cinematic%20illustration%2C%20dark%20gold%20tones%2C%20epic%20composition&width=400&height=560&seq=novel-cover-04&orientation=portrait',
    description: '五年前，他是军中战神，却被奸人所害，家破人亡。五年后，他携无敌之势归来，誓要让所有仇人付出代价。曾经的兄弟、红颜，还有那些看不起他的人，都将见证一代战神的崛起！',
    category: '战神归来',
    categorySlug: 'war-god-returns',
    rating: 9.7,
    wordCount: '356万字',
    status: 'ongoing',
    updateDate: '2026-08-07',
    chapters: 1780,
    tags: ['战神', '复仇', '热血', '铁血柔情'],
    views: 18900000,
    favorites: 1350000,
    content: '<h2>第一章 边境之王</h2><p>北境，寒风凛冽。</p><p>一座戒备森严的军事基地中，一个身材高大的男人正在翻阅手中的文件。</p><p>他叫秦战，代号"龙牙"，是北境军区的最高指挥官。五年前，他被仇家陷害，全家被杀，自己也险些丧命。是北境的老将军救了他，给了他重生的机会。</p><p>五年来，他在战场上浴血奋战，从一个普通的士兵成长为令敌人闻风丧胆的"龙牙战神"。</p><p>"将军，江城的消息传来了。"副官走进来，递上一份密报。</p><p>秦战接过密报，目光渐渐变得冷厉。</p><p>当年陷害他的仇人，如今在江城混得风生水起。赵家大少赵天豪，已经成了江城首富；而他曾经的未婚妻柳如烟，也即将嫁给赵天豪。</p><p>"五年了……"秦战站起身，眼中闪过一道寒芒，"是该回去算账了。"</p><p>当天夜里，一架军用直升机悄然离开了北境基地，朝着江城方向飞去。</p>',
  },
  {
    id: 5,
    title: '都市修仙传',
    author: '云中仙客',
    coverImage: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20surrounded%20by%20floating%20golden%20ancient%20runes%20and%20mystical%20energy%20in%20modern%20city%20street%2C%20contrast%20between%20ancient%20and%20modern%2C%20cinematic%20lighting%2C%20artistic%20fantasy%20illustration%2C%20gold%20and%20dark%20blue%20tones&width=400&height=560&seq=novel-cover-05&orientation=portrait',
    description: '仙界第一仙尊重生回到地球都市时代，从此开启了一段传奇之路。他以无上仙法纵横都市，炼丹、布阵、收徒、泡妞，样样精通。且看一代仙尊如何在红尘都市中，搅动风云，再登巅峰！',
    category: '玄幻都市',
    categorySlug: 'urban-fantasy',
    rating: 9.3,
    wordCount: '268万字',
    status: 'ongoing',
    updateDate: '2026-08-05',
    chapters: 1340,
    tags: ['修仙', '重生', '都市', '轻松'],
    views: 9800000,
    favorites: 678000,
    content: '<h2>第一章 仙尊重生</h2><p>陈玄缓缓睁开了眼睛。</p><p>入目是洁白的天花板，刺鼻的消毒水味道，以及窗外传来的汽车鸣笛声。</p><p>"我……回来了？"</p><p>陈玄难以置信地看着自己的双手——这是凡人的手，不再是那只可以翻江倒海的仙尊之手。</p><p>他记得，自己在渡劫飞升时，被九大仙帝联手偷袭，最终自爆元神，与敌人同归于尽。却没想到，一缕残魂竟然回到了地球——他最初生活的世界。</p><p>而此刻的他，附身在一个同名的大学生身上。这具身体的原主人，因为被女友劈腿、被富二代羞辱，一时想不开跳了楼。</p><p>"真是可笑。"陈玄摇了摇头，"区区凡尘琐事，也值得轻生？"</p><p>虽然一身仙力荡然无存，但他的记忆和功法还在。只要重新修炼，用不了多久，他就能恢复一部分实力。</p><p>在这个灵气稀薄的地球上，哪怕只有他全盛时期万分之一的实力，也足以傲视天下了。</p>',
  },
  {
    id: 6,
    title: '极品全能学生',
    author: '一叶飘零',
    coverImage: 'https://readdy.ai/api/search-image?query=Charismatic%20young%20Chinese%20student%20in%20school%20uniform%20surrounded%20by%20beautiful%20female%20classmates%2C%20campus%20setting%2C%20warm%20sunlight%2C%20romantic%20atmosphere%2C%20anime-inspired%20illustration%20style%2C%20soft%20golden%20and%20pink%20tones&width=400&height=560&seq=novel-cover-06&orientation=portrait',
    description: '普通高中生林凡意外获得全能系统，从此学渣变学霸，屌丝变男神。考试满分、篮球称霸、医术通天，他样样精通。冷艳校花、甜美同桌、火辣学姐……他的高中生活，精彩得让人羡慕不已！',
    category: '都市逆袭',
    categorySlug: 'urban-revenge',
    rating: 9.1,
    wordCount: '186万字',
    status: 'completed',
    updateDate: '2026-07-15',
    chapters: 920,
    tags: ['系统', '校园', '逆袭', '轻松'],
    views: 8500000,
    favorites: 523000,
    content: '<h2>第一章 全能系统</h2><p>"叮！全能系统已绑定宿主——林凡。"</p><p>"新手大礼包已发放：过目不忘（被动技能）、初级格斗术、初级医术。"</p><p>林凡呆坐在教室最后一排，脑海中突然响起的电子音让他整个人都懵了。</p><p>"系统？什么玩意儿？"他在心中默念。</p><p>瞬间，一个半透明的面板出现在他眼前：</p><p>宿主：林凡</p><p>等级：1</p><p>经验：0/100</p><p>技能：过目不忘（被动）、初级格斗术、初级医术</p><p>积分：1000</p><p>林凡瞪大了眼睛。他昨天还因为考试倒数第一被班主任当众批评，被班花嘲讽"废物一个"。今天居然绑定了一个系统？</p><p>就在这时，数学老师王老师走进教室，宣布道："今天进行模拟考试，成绩最差的同学，我会建议他转到普通班。"</p><p>所有人的目光都齐刷刷地看向了林凡。</p>',
  },
  {
    id: 7,
    title: '豪门千金倒追我',
    author: '夜色微凉',
    coverImage: 'https://readdy.ai/api/search-image?query=Handsome%20casual%20Chinese%20man%20being%20chased%20by%20elegant%20beautiful%20woman%20in%20luxury%20city%20setting%2C%20romantic%20comedy%20vibe%2C%20warm%20sunset%20lighting%2C%20modern%20illustration%20style%2C%20soft%20golden%20and%20rose%20tones&width=400&height=560&seq=novel-cover-07&orientation=portrait',
    description: '一个普通的快递小哥，某天送快递时误入豪门千金的闺房。从此，这位集万千宠爱于一身的千金大小姐，开始了疯狂的倒追之路。面对豪门千金的痴情追求，他将何去何从？',
    category: '豪门总裁',
    categorySlug: 'ceo-romance',
    rating: 9.2,
    wordCount: '156万字',
    status: 'ongoing',
    updateDate: '2026-08-04',
    chapters: 780,
    tags: ['倒追', '豪门', '甜宠', '轻松'],
    views: 7200000,
    favorites: 489000,
    content: '<h2>第一章 误入香闺</h2><p>"叮咚——"</p><p>"您的快递到了，请签收。"</p><p>张晨按响了门铃，手里拿着一个精致的包裹。作为一名快递小哥，他每天要送几百个包裹，但像今天这样送到半山别墅区的机会并不多。</p><p>门开了，但里面没有人。</p><p>"奇怪……"张晨探头看了看，犹豫了一下，还是推门走了进去。</p><p>这栋别墅内部的奢华程度远超他的想象。水晶吊灯、真皮沙发、名贵油画……每一样都透露出主人不凡的身份。</p><p>"有人在吗？快递——"</p><p>话音未落，张晨愣住了。</p><p>他推开了一扇半掩的门，看到了一个让他终生难忘的画面——一个穿着丝质睡裙的绝美女孩，正慵懒地躺在宽大的床上。</p><p>她有着一张精致到无可挑剔的脸庞，肌肤如雪，长发如瀑。此刻，她正睁着一双水汪汪的大眼睛，惊讶地看着这个突然闯入的陌生人。</p><p>"啊——！！！"</p><p>尖叫声响彻了整个别墅。</p>',
  },
  {
    id: 8,
    title: '极品太子爷',
    author: '江山如画',
    coverImage: 'https://readdy.ai/api/search-image?query=Noble%20elegant%20Chinese%20young%20man%20in%20luxury%20traditional%20style%20robe%20with%20modern%20elements%2C%20standing%20in%20grand%20ancient-modern%20fusion%20hall%2C%20golden%20hour%20lighting%2C%20artistic%20illustration%2C%20royal%20and%20mysterious%20atmosphere&width=400&height=560&seq=novel-cover-08&orientation=portrait',
    description: '他是京城最显赫的太子爷，权力滔天，财富如海。然而一场宫廷阴谋，让他流落民间。十年后，他以王者之姿重返京城。当年的真相，那些背叛他的人，都将付出惨痛的代价！',
    category: '战神归来',
    categorySlug: 'war-god-returns',
    rating: 9.6,
    wordCount: '298万字',
    status: 'ongoing',
    updateDate: '2026-08-06',
    chapters: 1490,
    tags: ['太子', '权谋', '复仇', '热血'],
    views: 13600000,
    favorites: 968000,
    content: '<h2>第一章 京城太子</h2><p>京城，紫禁之巅。</p><p>一个身着黑色风衣的年轻人负手而立，俯瞰着这座千年古都。他的眼神深邃而锐利，仿佛能洞穿一切。</p><p>他叫萧云龙，曾经是京城第一太子爷。十年前，他被人陷害，全家被灭门，只有他一人侥幸逃脱。十年来，他隐姓埋名，在暗处积蓄力量。</p><p>如今，他终于有了足够的实力，可以回来讨回属于他的一切。</p><p>"少爷，车已经准备好了。"身后，一个西装革履的中年人恭敬地说道。</p><p>萧云龙微微颔首，转身走向楼下。</p><p>楼下停着一排黑色的宾利轿车，数十名身着统一制服的保镖肃立两旁。这场面，就像是某国元首出行一般。</p><p>"出发。"萧云龙淡淡说了两个字。</p><p>车队缓缓启动，朝着京城中心驶去。</p><p>今天，他要去参加京城最顶级的商业宴会。到时候，所有当年参与陷害他的人，都会在场。</p><p>他要让他们知道——太子，回来了。</p>',
  },
  {
    id: 9,
    title: '花都特种兵王',
    author: '铁血丹心',
    coverImage: 'https://readdy.ai/api/search-image?query=Muscular%20tough%20Chinese%20special%20forces%20soldier%20in%20tactical%20gear%20in%20urban%20setting%2C%20action%20pose%2C%20dramatic%20explosive%20background%2C%20cinematic%20illustration%2C%20dark%20contrast%20with%20golden%20accents%2C%20movie%20poster%20style&width=400&height=560&seq=novel-cover-09&orientation=portrait',
    description: '他是特种兵中的王者，代号"狼牙"，执行过无数次不可能完成的任务。退役后回归都市，本想安安静静当个普通人，却被卷入各种风波。各路美女佳人纷至沓来，各方势力虎视眈眈。兵王出鞘，谁与争锋！',
    category: '战神归来',
    categorySlug: 'war-god-returns',
    rating: 9.5,
    wordCount: '245万字',
    status: 'ongoing',
    updateDate: '2026-08-05',
    chapters: 1220,
    tags: ['兵王', '特种兵', '热血', '铁血柔情'],
    views: 11200000,
    favorites: 812000,
    content: '<h2>第一章 退役归乡</h2><p>一列从边境驶来的火车缓缓停靠在江城站。</p><p>一个身材魁梧、面容刚毅的年轻人从车上走下来。他背着一个简单的军用背包，身上穿着一件洗得发白的迷彩T恤。</p><p>他叫韩锋，代号"狼牙"，东南军区特种大队的前任队长。半个月前，他正式退役，回到了阔别八年的故乡江城。</p><p>走在熟悉的街道上，韩锋心中百感交集。八年前，他还是一个懵懂少年，为了追逐军旅梦想而离开家乡。八年后，他带着满身伤痕和无数荣誉回来，却发现一切都已经变了。</p><p>"砰！"</p><p>突然，前方传来一声巨响。一辆失控的货车正朝着一个推着婴儿车的年轻妈妈冲去！</p><p>"小心！"韩锋瞳孔一缩，身体瞬间化作一道残影。</p><p>他的速度快得不可思议，几乎在一瞬间就冲到了那位年轻妈妈身边，一把将她连人带婴儿车推到了安全地带。与此同时，他单手撑地，一个翻身避开了冲来的货车。</p><p>"轰隆！"货车撞在了路边的墙壁上，发出巨大的声响。</p>',
  },
  {
    id: 10,
    title: '我的绝美女帝老婆',
    author: '天外飞仙',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20powerful%20Chinese%20empress%20in%20elegant%20phoenix%20gown%20standing%20with%20modern%20man%20in%20suit%2C%20ancient-modern%20fusion%2C%2C%20golden%20and%20crimson%20tones%2C%20dramatic%20artistic%20illustration%2C%20romantic%20fantasy%20atmosphere&width=400&height=560&seq=novel-cover-10&orientation=portrait',
    description: '他娶了一个倾国倾城的老婆，本以为只是普通的都市美女，没想到她竟是来自异世界的女帝！绝世容颜之下，隐藏着通天的修为和权力。从此，平凡的人生变得不再平凡，修仙、争霸、宠妻，一样都不能少！',
    category: '玄幻都市',
    categorySlug: 'urban-fantasy',
    rating: 9.4,
    wordCount: '223万字',
    status: 'ongoing',
    updateDate: '2026-08-03',
    chapters: 1110,
    tags: ['女帝', '修仙', '宠妻', '轻松'],
    views: 9500000,
    favorites: 698000,
    content: '<h2>第一章 我的老婆是女帝</h2><p>李昊觉得自己的人生简直像是开了挂。</p><p>三个月前，他还是一个连房租都交不起的穷屌丝。而现在，他住在江城最顶级的别墅里，开着限量版跑车，身边还有一个美若天仙的老婆。</p><p>他老婆叫苏月婵，不仅是江城出了名的大美女，还是苏氏集团的掌门人，身价上百亿。</p><p>但李昊一直觉得，苏月婵身上有什么秘密。</p><p>比如，她有时候会说一些他听不懂的话。比如，她偶尔会莫名其妙地"消失"几个小时。再比如，她的书房里总是锁着，从来不让他进去。</p><p>这天晚上，李昊终于忍不住了。</p><p>趁着苏月婵洗澡的时候，他用一根铁丝撬开了书房的锁。</p><p>书房里没什么特别的——除了墙上挂着的一幅巨大的古画。</p><p>画上是一个身披凤袍、头戴凤冠的女子坐在龙椅上，威仪万千，宛若女皇。而让李昊震惊的是——画上的女子，竟然和他老婆苏月婵长得一模一样！</p>',
  },
  {
    id: 11,
    title: '超级神医赘婿',
    author: '杏林春暖',
    coverImage: 'https://readdy.ai/api/search-image?query=Humble%20yet%20confident%20Chinese%20man%20holding%20silver%20acupuncture%20needles%20with%20subtle%20glow%2C%20standing%20before%20grand%20mansion%2C%20contrast%20between%20humility%20and%20hidden%20power%2C%20warm%20golden%20sunset%20lighting%2C%20artistic%20illustration&width=400&height=560&seq=novel-cover-11&orientation=portrait',
    description: '做了三年赘婿，所有人都当他是废物。直到有一天，岳母病危，他亮出了银针。从此，各路大佬跪求问诊，豪门千金投怀送抱。曾经看不起他的人，如今只能仰望他的背影！',
    category: '医武双绝',
    categorySlug: 'medical-martial',
    rating: 9.3,
    wordCount: '176万字',
    status: 'completed',
    updateDate: '2026-06-20',
    chapters: 880,
    tags: ['赘婿', '神医', '逆袭', '打脸'],
    views: 7800000,
    favorites: 545000,
    content: '<h2>第一章 三年赘婿</h2><p>"你这个废物，连洗个碗都洗不好！"</p><p>伴随着一声尖锐的呵斥，一只瓷碗在沈默脚边摔成了碎片。</p><p>沈默低着头，默默地蹲下身子，一片一片地捡着碎片。这三年，他已经习惯了这样的辱骂。</p><p>三年前，他入赘到了江城的周家。周家在江城虽然算不上什么豪门，但也有个几千万的资产。而他的岳母赵翠花，一直以他为耻。</p><p>"你看看人家王家的女婿，开的是宝马，住的是别墅！再看看你，整天窝在家里，连个工作都找不到！我们周家真是倒了八辈子霉，才招了你这么个废物！"</p><p>沈默没有说话，只是默默地继续捡碎片。</p><p>没有人知道，他其实是鬼医门的传人。师父临终前嘱托他入世修行，体验人间冷暖。所以这三年来，他一直隐忍不发。</p><p>直到这天晚上，周家发生了一件大事。</p><p>岳母赵翠花突然口吐白沫，倒在地上不省人事。</p>',
  },
  {
    id: 12,
    title: '都市之最强王者',
    author: '九天揽月',
    coverImage: 'https://readdy.ai/api/search-image?query=Powerful%20Chinese%20man%20sitting%20on%20throne-like%20chair%20in%20modern%20penthouse%20overlooking%20night%20city%2C%20surrounded%20by%20beautiful%20women%2C%20luxurious%20atmosphere%2C%20golden%20and%20amber%20lighting%2C%20artistic%20illustration&width=400&height=560&seq=novel-cover-12&orientation=portrait',
    description: '他是地下世界的王者，掌控着无尽的财富和权力。厌倦了打打杀杀的生活后，他选择归隐都市。然而树欲静而风不止，各路势力纷纷挑衅，各方美女频频出现。王者一怒，伏尸百万！',
    category: '都市逆袭',
    categorySlug: 'urban-revenge',
    rating: 9.8,
    wordCount: '398万字',
    status: 'ongoing',
    updateDate: '2026-08-07',
    chapters: 1990,
    tags: ['王者', '地下世界', '热血', '爽文'],
    views: 21000000,
    favorites: 1580000,
    content: '<h2>第一章 王者归来</h2><p>夜幕之下，一架私人飞机缓缓降落在江城国际机场。</p><p>机舱门打开，一个约莫三十岁的男人走了出来。他穿着一身黑色的休闲装，看起来就像是一个普通的游客。然而，机场跑道两侧，却站满了清一色黑西装的壮汉，齐刷刷地朝他鞠躬。</p><p>"恭迎王上归来！"</p><p>数百人的声音汇聚在一起，气势磅礴。</p><p>这个男人叫秦渊，在国际地下世界中，他有一个令人闻风丧胆的称号——"冥王"。</p><p>十年前，他从江城的街头混混起步，一步步成为了地下世界的无冕之王。他的势力遍布全球，手中的财富足以买下一个小国家。</p><p>十年前他离开江城时，所有人都认为他只是一个失败者。十年后他归来时，整个世界都要为他让路。</p><p>"王上，赵家的请柬已经送到了。"一个属下小跑过来，双手奉上一份烫金请柬。</p><p>秦渊接过请柬，嘴角勾起一抹玩味的笑容。赵家，当年正是他们带头打压他，逼得他远走他乡。</p><p>"告诉他们，我会准时赴约。"</p>',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '书虫小明',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20simple%20warm%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '这个网站太棒了！收录的小说质量都很高，每一本都让人欲罢不能。特别是《都市之最强王者》，我看了一个通宵根本停不下来！',
    date: '2026-08-05',
  },
  {
    id: 2,
    name: '夜雨声烦',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20elegant%20smile%2C%20modern%20style%2C%20simple%20warm%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '从《总裁的绝色娇妻》开始入坑，现在每天都要来刷更新。推荐给了好几个闺蜜，大家都说好看。最喜欢这种又甜又宠的文了！',
    date: '2026-08-03',
  },
  {
    id: 3,
    name: '江湖浪子',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%2C%20confident%20expression%2C%20business%20casual%2C%20simple%20warm%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    comment: '作为一个看了十年网文的老书虫，这个网站的选书眼光真的没话说。每一本都是精品，剧情紧凑不水字数，看得热血沸腾！',
    date: '2026-08-01',
  },
  {
    id: 4,
    name: '梦里花落',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20sweet%20smile%2C%20fresh%20style%2C%20simple%20warm%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 4,
    comment: '网站界面很清爽，阅读体验很好。最喜欢分类功能，可以快速找到喜欢的类型。希望能多更新一些后宫养成类的作品！',
    date: '2026-07-28',
  },
];

export const siteInfo = {
  name: '都市美艳后宫',
  tagline: '最强男主的极致宠溺之旅',
  description: '都市美艳后宫，汇聚最热血的都市爽文体验。从草根逆袭到万千美人环绕，极致宠溺与权谋并行，让你沉浸于最顶级的都市后宫幻想世界，感受无与伦比的阅读快感与情感共鸣。',
  keywords: '都市美艳后宫,都市后宫爽文,美艳女主角合集,都市逆袭小说,后宫养成系爽文,都市爽文推荐,男频热血后宫文',
  email: 'contact@meiyanhg.com',
  phone: '400-888-6666',
  address: '中国上海市浦东新区陆家嘴金融中心',
  foundingYear: 2023,
  totalNovels: 12000,
  totalReaders: 5800000,
  totalWords: 360000000,
};